{
  "title": "Allow access to your location?",
  "body": "By allowing access to your location we can make sure you arrived at the facility for check-in",
  "disagree": "Disagree",
  "agree": "Agree"
}
